import UseAxios from '../../../Api/http/http';
import { getKpiCateroryList, getKpiTargetFormat } from '../../../Api/request/manageKpi';


export const fetchKpiMasterDetails = async () => {
  try {
    const response = await UseAxios(getKpiCateroryList());
    const result = response?.data?.kpiDetails;
    return result;
  } catch (error) {
    return [];
  }
};

export const getTargetFormat = async () => {
  try {
    const response = await UseAxios(getKpiTargetFormat());
    const result = response.data.targets.map((item) => ({
      id: item.kpiFormatorId,
      name: item.format,
      ...item,
      options: item.options.map((option) => ({
        id: option.kpiOperatorId,
        name: option.combination,
        ...option,
      })),
    }));
    return result;
  } catch (error) {
    return [];
  }
};
